// =============================================================================
// Logger Utility
// All console output is suppressed unless test mode is active
// =============================================================================

type LogLevel = 'log' | 'info' | 'warn' | 'error'

let ENABLED = false

/**
 * Enable logging (called when test mode is activated)
 */
export function enableLogging() {
  ENABLED = true
}

function createLogger(level: LogLevel) {
  return (...args: unknown[]) => {
    if (ENABLED) {
      console[level](...args)
    }
  }
}

export const logger = {
  log: createLogger('log'),
  info: createLogger('info'),
  warn: createLogger('warn'),
  error: createLogger('error'),
}

// For backwards compatibility - can be used as drop-in replacement for console.log
export const log = logger.log
